import { SHARE_PERCENT } from "../actions/types";

export default function shares(state = { shares: [] }, action) {
	const { type, payload } = action;
	switch (type) {
		case SHARE_PERCENT:
			return { ...state, shares: payload.data };

		default:
			return state;
	}
}
